/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Update_TitleInputs */

const vi_einvoice_credential_update_title = /** @type {(inputs: Einvoice_Credential_Update_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật kết nối MISA`)
};

/**

* @param {Einvoice_Credential_Update_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_update_title = /** @type {((inputs?: Einvoice_Credential_Update_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Update_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_update_title(inputs)
});